import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API } from '../../api/services';
import { API_METHOD } from '../../api/services/apiMethods';

export const getFolder: any = createAsyncThunk('getFolder/getFolderDetails', async (res) => {
    const response = await API.post(API_METHOD.Misc.GET_FOLDER_DETAILS, res);
    return response.data;
});

